import * as React from 'react'

import { DetailInfo } from '~shared/components/Detail/DetailInfo'

import { useAddonDetailStateCtx } from '../contexts/AddonDetailStateProvider'

type TProps = NoChildren
/**
 * DetailInfo connected to addon detail context data.
 */
export const AddonDetailInfo: React.FC<TProps> = () => {
  const { addon, isFetching } = useAddonDetailStateCtx()

  return (
    <DetailInfo
      hasStickyHeading={false}
      showSkeleton={isFetching}
      nameLabel={addon.nameLabel}
      allergens={addon.allergens}
      descriptionLabel={addon.descriptionLabel}
      ageControl={addon.ageControl}
    />
  )
}
